import { createSlice } from "@reduxjs/toolkit";

const initialGamesFiltersModalSlice = { isOpen: false }

const gamesFiltersModalSlice = createSlice({
    name: 'games_filters_modal',
    initialState: initialGamesFiltersModalSlice,
    reducers: {
        openModal(state) {
            state.isOpen = true
        },
        closeModal(state) {
            state.isOpen = false
        }
    }
})

export const gamesFiltersModalActions = gamesFiltersModalSlice.actions;
export default gamesFiltersModalSlice